import { Directive, TemplateRef } from '@angular/core'

import { UiDataTableActionsContext } from './ui-data-table.model'

@Directive({
    selector: '[uiTableActions]',
    standalone: true
})
export class UiTableActionsDirective<T = unknown> {
    constructor(public template: TemplateRef<UiDataTableActionsContext<T>>) {}

    static ngTemplateContextGuard<T>(
        _dir: UiTableActionsDirective<T>,
        ctx: unknown
    ): ctx is UiDataTableActionsContext<T> {
        return true
    }
}
